export enum ConfirmationMessageType {
  TEXT,
  HTML,
}
